import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface FileDocumentItem {
  id: string;
  name: string;
}

@Component({
  standalone: false,
  selector: "app-file-document",
  templateUrl: "./file-document.component.html",
  styleUrls: ["./file-document.component.scss"]
})
export class FileDocumentComponent {
  @Input({ required: true }) file!: FileDocumentItem;
  // Default true: every existing consumer already binds (preview), so this replaces the old
  // click-anywhere-on-card interaction with an explicit action for all of them automatically.
  @Input() canPreview = true;
  @Input() canDownload = true;
  @Input() canRename = false;
  @Input() canDelete = false;
  @Input() canInfo = false;
  // Disables the action buttons while a preview/download/rename/delete for
  // this specific file is in flight, preventing a double-submit on slow networks.
  @Input() busy = false;

  @Output() preview = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();
  @Output() renameRequested = new EventEmitter<void>();
  @Output() deleteRequested = new EventEmitter<void>();
  @Output() info = new EventEmitter<void>();

  get fileIcon(): string {
    const name = this.file?.name || "";
    const dot = name.lastIndexOf(".");
    const ext = dot !== -1 ? name.substring(dot + 1).toLowerCase() : "";
    if (ext === "pdf") return "FileText";
    if (["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp"].includes(ext)) return "Newspaper";
    if (["xlsx", "xls", "csv"].includes(ext)) return "Table";
    if (["doc", "docx", "txt", "rtf"].includes(ext)) return "FileText";
    return "Paperclip";
  }
}
